import { defineStore } from "pinia";
import type { Withdrawal } from "@/gen/api/v1/api_pb";
import { create } from "@bufbuild/protobuf";
import {
  ListWithdrawalsRequestSchema,
  CreateWithdrawalRequestSchema,
} from "@/gen/api/v1/api_pb";
import { withdrawalService } from "@/services/withdrawal.service";

export interface WithdrawalState {
  withdrawals: Withdrawal[];
  isLoading: boolean;
}

export const useWithdrawalStore = defineStore("withdrawal", {
  state: (): WithdrawalState => ({
    withdrawals: [],
    isLoading: false,
  }),

  actions: {
    async fetchWithdrawals() {
      this.isLoading = true;
      try {
        const response = await withdrawalService.listWithdrawals(
          create(ListWithdrawalsRequestSchema, {
            page: 1,
            pageSize: 10,
          }),
        );
        this.withdrawals = response.withdrawals;
      } catch (error) {
        console.error("Falha ao buscar withdrawals:", error);
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Cria um saque.
     * IMPORTANTE: CreateWithdrawalRequest NÃO possui campo nested "withdrawal".
     * Envie os campos no nível superior (userId, amount, pixKeyId?).
     */
    async createWithdrawal(payload: {
      userId: number;
      amount: number;
      pixKeyId?: number | string;
    }) {
      this.isLoading = true;
      try {
        const req = create(CreateWithdrawalRequestSchema, {
          amount: Number(payload.amount),
          ...(payload.pixKeyId != null
            ? { pixKeyId: Number(payload.pixKeyId) }
            : {}),
        });

        const created = await withdrawalService.createWithdrawal(req);
        this.withdrawals.push(created as Withdrawal);
      } catch (error) {
        console.error("Falha ao criar withdrawal:", error);
      } finally {
        this.isLoading = false;
      }
    },
  },
});
